import { useEffect, useState } from 'react'
import { useAuth } from '@/components/unholster/react-authkit'

import { gql, useLazyQuery } from '@apollo/client'
import { Avatar, AvatarFallback } from '@/components/ui/avatar'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

const getMe = gql`
  query {
    me {
      email
      firstName
      lastName
      username
    }
  }
`

interface ResponseMe {
  email: string
  firstName: string
  lastName: string
  username: string
}

export function User() {
  const auth = useAuth()
  const [getMeQuery] = useLazyQuery(getMe)

  const [userData, setUserData] = useState({
    acronym: '',
    email: '',
    name: '',
  })

  useEffect(() => {
    getMeQuery().then(({ data }) => {
      const response: ResponseMe = data.me
      let acronym = response.firstName[0]
      let name = response.firstName
      if (response.lastName) {
        acronym += response.lastName[0]
        name += ` ${response.lastName}`
      }

      setUserData({
        acronym: acronym.toUpperCase(),
        email: response.username ?? '',
        name,
      })
    })
  }, [])

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <div className="flex | items-center | gap-2">
          <Avatar className="w-8 | h-8">
            <AvatarFallback className="bg-[#ACACAC] | text-white | font-normal | text-[14px]">
              {userData.acronym}
            </AvatarFallback>
          </Avatar>
        </div>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="bg-white">
        <DropdownMenuLabel className="font-medium">{userData.name}</DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuItem
          className="cursor-pointer"
          onClick={() => {
            auth.logout(encodeURIComponent(window.location.origin))
          }}
        >
          Cerrar sesión
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
